module.exports = __webpack_public_path__ + "static/media/phone-02.e2f4733f.png";